"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupUpdateRequestResultTermin = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.GroupUpdateRequestResultTermin = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
};
